
import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'
import { format } from '../../../../../common/services/date.service'


export default function ShipmentBasicInfoComponent({ orderStatus, selectShipping, handleInnerFormChange, transportAgents }: any) {
  return (
    <>
      <AccordionContainer
        child={

          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled
              label="Customer Name"
              name="RAPCustomerName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RAPCustomerName'
                )
              }}
              type="text"
              value={selectShipping?.RAPCustomerName}
            />
            <InputContainer
              isDisabled
              label="Product Name"
              name="MobilityProductName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityProductName'
                )
              }}
              type="text"
              value={selectShipping?.MobilityProductName}
            />
            <InputContainer
              label="OrderStatus"
              labelField="Text"
              list={orderStatus}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityOrderStatusId'
                )
              }}
              optionName='Choose OrderStatus'
              type="select"
              value={selectShipping?.MobilityOrderStatusId}
              valueField="Value"
            />
            <InputContainer
              isDisabled
              label="Operator"
              name="RAPName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RAPName'
                )
              }}
              type="text"
              value={selectShipping?.RAPName}
            />
            <InputContainer
              label="Operator Agent"
              labelField="Name"
              list={transportAgents}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RAPAgentId'
                )
              }}
              optionName='Choose Agent'
              type="select"
              value={selectShipping?.RAPAgentId}
              valueField="Id"
            />
            <InputContainer
              isDisabled
              label="Order PId"
              name="MobilityOrderPId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityOrderPId'
                )
              }}
              type="text"
              value={selectShipping?.MobilityOrderPId}
            />
            <InputContainer
              isDisabled
              label="Invoice Number"
              name="InvoiceNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'InvoiceNumber'
                )
              }}

              type="text"
              value={selectShipping?.InvoiceNumber}
            />
            <InputContainer
              isDisabled
              label="Tracking Number"
              name="TrackingNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TrackingNumber'
                )
              }}

              type="text"
              value={selectShipping?.TrackingNumber}
            />

            <InputContainer
              isDisabled
              label="ShippedDate"
              name="ShippedDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShippedDateUtc'
                )
              }}

              type="date"
              value={format(selectShipping?.ShippedDateUtc)}
            />
            <InputContainer
              isDisabled
              label="DeliveryDate"
              name="DeliveryDateUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DeliveryDateUtc'
                )
              }}

              type="date"
              value={format(selectShipping?.DeliveryDateUtc)}
            />

            <InputContainer
              isDisabled
              label="Notes"
              name="MobilityOrderNotes"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MobilityOrderNotes'
                )
              }}
              type="text"
              value={selectShipping?.MobilityOrderNotes}
            />
            <InputContainer
              isDisabled
              label="Pickup Code"
              name="PickupCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PickupCode'
                )
              }}
              type="text"
              value={selectShipping?.PickupCode}
            />
            <InputContainer
              isDisabled
              label="Delivery Code"
              name="DeliveryCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DeliveryCode'
                )
              }}
              type="text"
              value={selectShipping?.DeliveryCode}
            />


            <InputContainer
              isDisabled
              label="Mobility Order"
              name="IsMobilityOrder"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsMobilityOrder'
                )
              }}
              type="checkbox"
              value={selectShipping?.IsMobilityOrder}
            />

            <InputContainer
              isDisabled
              label="Order By Vendor"
              name="IsMobilityOrderByVendor"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsMobilityOrderByVendor'
                )
              }}
              type="checkbox"
              value={selectShipping?.IsMobilityOrderByVendor}
            />
            <InputContainer
              isDisabled
              label="Price"
              name="Price"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'OrderTotal'
                )
              }}
              type="text"
              value={selectShipping?.OrderTotal}
            />
          </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Info"
      />


    </>
  )
}